import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import AgGrid from '../../../common/components/ag-grid/ag-grid'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { getDaysMonthYear, makePayload, getCorrespondingTowerName, getCoreValues } from '../utils'
import { MonthYearDropDown } from './monthYearDropdown'
import { ReasonCodeAndDescription } from './reasonCodeAndDescription'
import { NumericCellEditor } from '../../../common/NumericCellEditor';

@inject('NGLTowerConstraintsStore')
@observer
class NGLTowerConstraints extends Component {
    constructor(props) {
        super(props)
        this.state = {
            gridOptions: {
                singleClickEdit: true,
                pagination: false,
                stopEditingWhenGridLosesFocus: true,
                autoSizeAllColumns: true,
                floatingFilter: true,
                enableRangeSelection: true,
                rowGroupPanelShow: 'always',
                suppressMenu: false,
                frameworkComponents: {
                    NumericCellEditor: NumericCellEditor,
                },
            },
            defaultColDef: {
                enableRowGroup: true,
                enablePivot: true,
                enableValue: true,
                sortable: true,
                filter: true,
                resizable: true,
                autoHeight: true,
                wrapHeaderText: true,
                autoHeaderHeight: true
            },
        }
    }

    render() {
        const {
            screenRowData,
            screenColumnDefinitions,
            selectedDate,
            comments
        } = this.props.NGLTowerConstraintsStore;
        const { gridOptions } = this.state
        const parentScreen = this.getCurrentScreenParent();
        return (
            <>
                <div className="col-md-12">
                    <div className="cb-title-container">
                        <h3 className="cb-title">{parentScreen.screen.title}</h3>
                    </div>
                    <>
                        <div
                            className={`nglteam-header-row 
                            sticky-top rounded datepicker-btn-container`}
                        >
                            <div>
                                <MonthYearDropDown
                                    selectedDate={selectedDate}
                                    onChangeSelectedDate={this.onChangeSelectedDate}
                                />
                            </div>
                            <div>
                                <button
                                    type="save"
                                    className="btn btn-primary btn-grid active"
                                    aria-expanded="false"
                                    onClick={this.saveScreenData}
                                    disabled={!screenRowData.length}
                                >
                                    <FontAwesomeIcon icon={faSave} />
                                    Save Data
                                </button>
                            </div>
                        </div>
                    </>
                </div>
                <AgGrid
                    gridID={'TowerConstraints'}
                    gridOptions={gridOptions}
                    rowData={screenRowData}
                    columnDefs={screenColumnDefinitions}
                    onCellValueChanged={this.onCellValueChanged.bind(this)}
                />
                <div className='col-md-12'>
                    <div className='col-md-12'>
                        <div className='row'>
                            <div className='col-md-2'>
                                <ReasonCodeAndDescription />
                            </div>
                            <div className='col-md-10'>
                                <h6>Comments</h6>
                                <textarea
                                    id='towercomments'
                                    name='towercomments'
                                    cols={127}
                                    rows={11}
                                    value={comments}
                                    onChange={this.handleCommentsChange}
                                    className='tower-comments'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    async componentDidMount() {
        await this.getScreenData()
    }

    // API call to retrive data
    getScreenData = async () => {
        const { NGLTowerConstraintsStore, CommonStore } = this.props
        const { selectedDate } = NGLTowerConstraintsStore
        const { selectedMonth, daysInMonth, selectedYear } = getDaysMonthYear(selectedDate)
        const payload = makePayload(daysInMonth, selectedMonth, selectedYear)
        await NGLTowerConstraintsStore.getScreenData(payload, CommonStore);
    }

    onChangeSelectedDate = (date) => {
        const { NGLTowerConstraintsStore } = this.props
        NGLTowerConstraintsStore.selectedDate = date
        this.getScreenData()
    }

    getCurrentScreenParent = () => {
        const { CommonStore, path } = this.props
        const parentScreenName = path.split('/').pop();
        const parentScreen = CommonStore.screenDetails.find(
            screenDetail => screenDetail.screen.name === parentScreenName
        );

        return parentScreen;
    };

    saveScreenData = async () => {
        const { CommonStore, NGLTowerConstraintsStore } = this.props;
        await NGLTowerConstraintsStore.saveScreenData(CommonStore)
        await this.getScreenData()
    };

    onCellValueChanged = (event) => {
        const { NGLTowerConstraintsStore } = this.props
        const { gridOptions } = this.state
        if (event.oldValue !== event.newValue) {
            const towerName = getCorrespondingTowerName(event.colDef.field)
            const { ID, UpdatedBy, UpdatedOn } = getCoreValues(towerName,
                event.data.Date, NGLTowerConstraintsStore.screenRowDataBackup
            )
            const existingIndex = NGLTowerConstraintsStore.rowsUpdated.findIndex(item =>
                item.ID === ID && item.Date === event.data.Date
            )
            const existingItem = NGLTowerConstraintsStore.rowsUpdated.find(item =>
                item.ID === ID && item.Date === event.data.Date
            )
            if (existingIndex > -1) {
                NGLTowerConstraintsStore.rowsUpdated.splice(existingIndex, 1)
            }
            NGLTowerConstraintsStore.rowsUpdated.push({
                ID: ID,
                Date: event.data.Date,
                Tower: towerName,
                GridTowerName: event.colDef.field,
                Reason: event.colDef.field.includes('ADJHRSOFFLINE') ?
                    existingItem?.Reason : event?.newValue,
                AdjustedHoursOffline: event.colDef.field.includes('ADJHRSOFFLINE') ?
                    event?.newValue : existingItem?.AdjustedHoursOffline,
                UpdatedBy,
                UpdatedOn
            });
            gridOptions.api.refreshCells();
        }
        else if (event.oldValue === event.newValue && event.newValue === '') {
            gridOptions.api.refreshCells();
        }
        else {
            event.node.setDataValue(event.colDef.field, event.oldValue);
            gridOptions.api.refreshCells();
        }
    };

    handleCommentsChange = event => {
        const { NGLTowerConstraintsStore } = this.props
        NGLTowerConstraintsStore.comments = event.target.value
    }
}

export default NGLTowerConstraints